import {
    createNoRequiredFilters,
    createShowConstraintsModal,
    createSkipSearch,
} from '@utils/constraintFilters';

const ALLOWED_DAYS = 7;

const REPORTS_SEVEN_DAY_MODAL_MESSAGE = 'If you use a time range larger than 7 days, you also have to select an option '
    + 'in at least one of the following filters: "Property licence", "Category", "1st stage category", '
    + '"2nd level category", "Report" ("None"/"Partial")';

const noRequiredFilters = createNoRequiredFilters({
    allowedDays: ALLOWED_DAYS,
    emptyFilterKeys: [
        'propertyLicences',
        'tournamentCategories',
        'firstStageCategories',
        'contentCategoriesLevel2',
    ],
    reportKey: 'report',
});

export const skipSearch = createSkipSearch(noRequiredFilters);
export const showConstraintsModal = createShowConstraintsModal(noRequiredFilters, REPORTS_SEVEN_DAY_MODAL_MESSAGE);
